module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp2_8011.b24a2289.png";